const jsFormFieldEventListener = (element) => {
  element.querySelectorAll(".js-form-field")
    .forEach((element) => {
      const selector = element.getAttribute("data-selector")
      const label = element.querySelector("label")
      const input = element.querySelector(selector)

      input.addEventListener("focus", () => {
        label.classList.remove("translate-y-2.5")
        label.classList.add("text-sm")
      });

      input.addEventListener("blur", () => {
        if (input.value === "") {
          label.classList.add("translate-y-2.5")
          label.classList.remove("text-sm")
        }
        else {
          label.classList.remove("translate-y-2.5")
          label.classList.add("text-sm")
        }
      })

      if (input.value.length || input.nodeName === 'SELECT' || input.type ==='tel') {
        label.classList.remove("translate-y-2.5")
        label.classList.add("text-sm")
      }
    })
}

export default jsFormFieldEventListener
